var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        title: _vm.$t("orderCenterCont.ViewDetails"),
        visible: _vm.visible,
        "custom-class": "order-log-drawer",
        direction: "ltr",
        size: "70%",
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$emit("update:visible", $event)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "preStyle" },
        [
          _c(
            "el-form",
            {
              ref: "updateForm",
              staticStyle: {
                padding: "20px",
                height: "calc(100vh - 68px)",
                "overflow-y": "auto",
              },
              attrs: { model: _vm.updateForm },
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("orderCenterCont.TheOrderNumber") + "：",
                              prop: "orderNumber",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.updateForm.orderNumber)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("operationCenter.client") + "：",
                              prop: "customerName",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.updateForm.customerName)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label:
                                _vm.$t("orderCenterCont.RequestTime") + "：",
                              prop: "createTime",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.updateForm.createTime)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c("receive-address-comparison", {
                attrs: { record: _vm.updateForm },
              }),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("orderCenterCont.AnjunParameters")
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "messageCon" }, [
                            _vm.updateForm.dealedRequestParams
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      "line-height": "25px",
                                      padding: "5px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                      staticStyle: {
                                        "font-size": "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        title: _vm.$t("orderCenterCont.copy"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy(
                                            _vm.updateForm.dealedRequestParams
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("pre", [
                              _vm._v(
                                _vm._s(_vm.updateForm.dealedRequestParams)
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "orderCenterCont.AnjunReturnsParameters"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "messageCon" }, [
                            _vm.updateForm.dealedResponseParams
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      "line-height": "25px",
                                      padding: "5px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                      staticStyle: {
                                        "font-size": "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        title: _vm.$t("orderCenterCont.copy"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy(
                                            _vm.updateForm.dealedResponseParams
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("pre", [
                              _vm._v(
                                _vm._s(_vm.updateForm.dealedResponseParams)
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("orderCenterCont.SupplierParameters")
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "messageCon" }, [
                            _vm.updateForm.originalRequestParams
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      "line-height": "25px",
                                      padding: "5px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                      staticStyle: {
                                        "font-size": "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        title: _vm.$t("orderCenterCont.copy"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy(
                                            _vm.updateForm.originalRequestParams
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("pre", [
                              _vm._v(
                                _vm._s(_vm.updateForm.originalRequestParams)
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "orderCenterCont.SupplierReturnsParameters"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "messageCon" }, [
                            _vm.updateForm.originalResponseParams
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      "line-height": "25px",
                                      padding: "5px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                      staticStyle: {
                                        "font-size": "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        title: _vm.$t("orderCenterCont.copy"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy(
                                            _vm.updateForm
                                              .originalResponseParams
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("pre", [
                              _vm._v(
                                _vm._s(_vm.updateForm.originalResponseParams)
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("orderCenterCont.CustomerParameters")
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "messageCon" }, [
                            _vm.updateForm.requestParams
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      "line-height": "25px",
                                      padding: "5px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                      staticStyle: {
                                        "font-size": "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        title: _vm.$t("orderCenterCont.copy"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy(
                                            _vm.updateForm.requestParams
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("pre", [
                              _vm._v(_vm._s(_vm.updateForm.requestParams)),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content bg-purple-light" },
                      [
                        _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "orderCenterCont.CustomerReturnParameters"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "messageCon" }, [
                            _vm.updateForm.responseParams
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      "line-height": "25px",
                                      padding: "5px",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-copy-document",
                                      staticStyle: {
                                        "font-size": "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        title: _vm.$t("orderCenterCont.copy"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copy(
                                            _vm.updateForm.responseParams
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c("pre", [
                              _vm._v(_vm._s(_vm.updateForm.responseParams)),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }